import { takeLatest, call } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { reorderListAndFractal } from "./helpers/updateOrderListAndFractal"
import { displaySelectionOrderSelector, displaySelectionItemOrderSelector } from "./helpers"


function* updateOrder({payload}) {
    const { oldIndex, newIndex } = yield payload

    yield call(reorderListAndFractal, oldIndex, newIndex, actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ORDER, actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM_ORDER, displaySelectionOrderSelector, displaySelectionItemOrderSelector)
}

export function* watchUpdateSelectionsDisplayOrder() {
    try {
        yield takeLatest(actionTypes.ITEMSELECTIONSDISPLAY_REQUEST_UPDATE_ORDER, updateOrder)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}